import { LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
import { appFooterStyles } from './app-footer.css';
import { renderAppFooterPresentation } from './app-footer-presentation';

@customElement('app-footer')
export class AppFooter extends LitElement {
  static styles = [appFooterStyles];

  render() {
    return renderAppFooterPresentation();
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'app-footer': AppFooter;
  }
}
